
export interface GetCaseListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCaseListPagingAndFilterResponseData
}

export interface GetCaseListPagingAndFilterResponseData {
    items: GetCaseListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCaseListPagingAndFilterResponseItem {
    caseId: string
    companyId: string
    name: string
    openingBalance: number
    currencyTypeId: string
    accountingCode?: string
    openingBalanceDate: string
    isCustomActive: boolean
    currencyTypeName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCaseListPagingAndFilterResponseData: GetCaseListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}